import { makeStyles, Paper } from "@material-ui/core";
import StepContainer from "components/request-document/StepContainer";
import { SMART_T_STEP } from "libs/constant/Step";
import AdminButtonController from "pages/admin/smart-visa/AdminButtonController";
import { AdminCancelVisaPage } from "pages/user/CancelVisaPage";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { getAllDocumentsList, setDocDetail } from "redux/modules/allDocumentsSlice";
import { getPersonalDetail } from "redux/modules/personalSlice";
import { setSmartFormStep } from "redux/modules/uiSlice";
import { getSmartForm, setSmartFormSetDraftId, setSmartServiceId } from "redux/modules/visaForm";

const useStyles = makeStyles((theme) => ({
  paper: {
    flexDirection: "column",
    flexWrap: "wrap",
    padding: theme.spacing(4),
    borderRadius: 16,
    // marginBottom: 60
  },
  wrapBtnControl: {
    width: "100%", bottom: 0, backgroundColor: "white", zIndex: 1, border: "1px solid rgba(0, 0, 0, 0.12)", borderRadius: "10px", borderLeftWidth: "1px", borderRightWidth: "1px", padding: "15px",
    position: "sticky", marginTop: "30px"
  }
}));

function CancelDetailPage() {
  const classes = useStyles();
  let { search } = useLocation();
  const query = new URLSearchParams(search);
  const draftId = query.get('draftId');
  const dispatch = useDispatch();

  useEffect(() => {
    async function fetchData() {
      dispatch(setSmartFormSetDraftId(draftId))
      const res = await dispatch(getAllDocumentsList({ draftId }));
      if (res.payload && res.payload.length > 0) {
        const detail = res.payload[0];
        await dispatch(getPersonalDetail({ personalId: detail.personalId }))
        dispatch(setSmartServiceId(detail.smartserviceId));
        dispatch(setDocDetail(detail));
      }
    }
    fetchData();
  }, [dispatch, draftId]);

  return (
    <Paper className={classes.paper} id="admin-view">
      <AdminCancelVisaPage />
      {/* <div className={classes.wrapBtnControl}>
        test
      </div> */}

      <div className={classes.wrapBtnControl}>
        <AdminButtonController />
      </div>


    </Paper>
  );
}

export default CancelDetailPage;

